import type { PropsWithChildren } from 'react'
import type { AuthMode } from '@steelhouse/auth-client-bridge'
import { NextAuthProvider } from '@steelhouse/auth-next/client'

import { clientAuthConfig } from '@mntn-dev/authentication-types'
import { CenteredLayout } from '@mntn-dev/ui-components/centered-layout'
import { LoadingCenter } from '@mntn-dev/ui-components/loading'
import { runningOnServer } from '@mntn-dev/utilities'

import { AuthLoaded } from './components/auth-loaded.tsx'
import { AuthLoading } from './components/auth-loading.tsx'

export const AuthenticationProvider = ({
  children,
  mode,
}: PropsWithChildren<{ mode: AuthMode }>) => {
  const authConfig = clientAuthConfig()

  return (
    <NextAuthProvider
      config={{
        ...authConfig[mode],
        deprecated_publishableKey: authConfig.clerk.publishableKey,
        apiBaseUrl: runningOnServer()
          ? authConfig.apiBaseUrl
          : window.location.origin,
      }}
      forceClient={mode}
    >
      <AuthLoaded>{children}</AuthLoaded>
      <AuthLoading>
        <CenteredLayout>
          <LoadingCenter />
        </CenteredLayout>
      </AuthLoading>
    </NextAuthProvider>
  )
}

export const SoftAuthenticationProvider = ({
  children,
  mode,
}: PropsWithChildren<{ mode: AuthMode }>) => {
  const authConfig = clientAuthConfig()

  return (
    <NextAuthProvider
      config={{
        ...authConfig,
        ...authConfig[mode],
        deprecated_publishableKey: authConfig.clerk.publishableKey,
        apiBaseUrl: runningOnServer()
          ? authConfig.apiBaseUrl
          : window.location.origin,
      }}
      forceClient={mode}
    >
      {children}
    </NextAuthProvider>
  )
}
